module.exports = __webpack_public_path__ + "static/media/record-vinyl.65f63ced.svg";